import { render, staticRenderFns } from "./left_store_info_goods.vue?vue&type=template&id=4be41878&scoped=true&"
import script from "./left_store_info_goods.vue?vue&type=script&lang=js&"
export * from "./left_store_info_goods.vue?vue&type=script&lang=js&"
import style0 from "./left_store_info_goods.vue?vue&type=style&index=0&id=4be41878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be41878",
  null
  
)

export default component.exports